/* eslint-disable react/prop-types */
import { h } from 'preact';

const selectAddonShots = (name) => {
  switch (name) {
    case 'Small':
      return '(3 shots)';
    case 'Medium':
      return '(4 shots)';
    case 'Large':
      return '(5 shots)';
    default:
      return '';
  }
};

const Addon = ({ option, dispatch }) => {
  const removeOption = () => {
    dispatch({
      type: 'REMOVE_AO',
      payload: option,
    });
  };

  const changeOption = (e) => {
    dispatch({
      type: 'CHANGE_AO',
      payload: option.variants[e.currentTarget.value],
    });
    // Note: this is to allow totals to be updated on change
    // we cannot use useEffect for this because it doesn't do deep comparison
    dispatch({
      type: 'UPDATE_TOTAL',
    });
  };

  return (
    <div className="curbside_options-option" style="margin-bottom: 0.5em;">
      <span className="SingleOptionSelector-0">{option.title}</span>
      <div className="curbside_options-option--active">
        <select style="margin-right: 0.75em;" onChange={changeOption}>
          {option.variants.map((variant, idx) => {
            return (
              <option key={variant.id} value={idx} defaultSelected={idx == 0}>
                {variant.title} {selectAddonShots(variant.title)} - $
                {`${(variant.price / 100).toFixed(2)}`}
              </option>
            );
          })}
        </select>
        <button
          className="btn btn--secondary-accent"
          style="display: grid; place-items: center;"
          onClick={removeOption}
          title="Remove Option"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            width="1.25em"
          >
            <path
              fillRule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Addon;
